import { WalletBasicType, WalletDetailsType, WalletTransactionResponseType } from "../types/walletTypes";
import { doApiGet } from "./Requests";

export const walletApi = {
    getCompanyWallets: () =>
        doApiGet<WalletBasicType[]>(`/api/wallets/company`),

    getWalletDetails: (walletId: string) =>
        doApiGet<WalletDetailsType>(`/api/wallets/${walletId}/company`),

    getUserWalletDetails: (walletId: string) =>
        doApiGet<WalletDetailsType>(`/api/wallets/${walletId}/employeeuser`),

    getWalletTransactions: (
        walletId: string,
        offset?: number,
        limit?: number,
        startDate?: string,
        endDate?: string,
        userId?: string
    ) => {
        const queryParams: string[] = [];
        const useOffsetLimit = !startDate && !endDate;
        if (useOffsetLimit) {
            if (offset !== undefined) queryParams.push(`offset=${offset}`);
            if (limit !== undefined) queryParams.push(`limit=${limit}`);
        } else {
            if (startDate) queryParams.push(`startDateTime=${startDate}`);
            if (endDate) queryParams.push(`endDateTime=${endDate}`);
        }
        if (userId && userId !== "all") {
            queryParams.push(`userId=${userId}`);
        }

        const queryString = queryParams.join("&");
        return doApiGet<WalletTransactionResponseType>(
            `/api/wallets/${walletId}/transactions?${queryString}`
        );
    }
};